import {AbstractTransitionManager} from './AbstractTransitionManager';
import {DPlexArguments} from './DPlexArguments';
import {FadeTransition} from './transitions/FadeTransition';
import {Hamburger} from './Hamburger';

export class TransitionManager extends AbstractTransitionManager {

    public async navigate(args:DPlexArguments) {
        let md=args.metadata;
        let sy=md.enter.scrollY;
        new Hamburger($('.hamburger')).close();
        await new FadeTransition(args).play();
        this.updateZones(args);
    }

    private updateZones(args:DPlexArguments) {
        $('[data-zone]').each((index,element) => {
            this.updateZone(args,$(element).data('zone'));
        });
    }
}

export {};